import React from 'react'
import { withTranslation } from 'react-i18next'
import Button from 'app/components/ButtonDefault'
import { ISingleProtrackLevelProps } from '../interface'
import Divider from 'app/components/Divider/Divider'
import '../styles.scss'
import './styles.scss'

export const bc = 'protrack-level'

const SingleProTrack: React.FC<ISingleProtrackLevelProps> = ({ t, setQueriesAndGoToDashboard, proTrackLevel }) => {
  const activity = proTrackLevel?.activities?.[0]

  return proTrackLevel && activity ? (
    <div className={`${bc}__wrapper single`}>
      <div className={`${bc}__image-wrapper`}>
        <img className={`${bc}__image`} src={activity.image} alt="welcome image" />
      </div>

      <div className={`${bc}__activity-wrapper`}>
        <div className={`${bc}__proquote-wrapper`}>
          <p className={`${bc}__proquote`}>“{activity.proQuote}”</p>
          <p className={`${bc}__proquote-author`}>— {activity.proQuoteAuthor}</p>
        </div>

        <Divider />

        <div className={`${bc}__activity single`}>
          <p className={`${bc}__activity-name single`}>{activity.name}</p>
          <p
            className={`${bc}__activity-description single`}
            dangerouslySetInnerHTML={{ __html: activity.description }}
          />
          <Button
            primary
            className={`${bc}__button single`}
            onClick={() => setQueriesAndGoToDashboard(proTrackLevel.id)}
          >
            {t('I Commit')}
          </Button>
        </div>
      </div>
      <Divider />
    </div>
  ) : null
}

export default withTranslation('user')(SingleProTrack)
